import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.RideMechanic;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "RideMechanic.Phaser.IntroductionScene.1",
            "RideMechanic.Phaser.IntroductionScene.2",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/RideMechanicGame/scenes/GameIntro.ts